import CommonStore from "../common_store";
import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../../api";
import { message } from "antd";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// 扩展 dayjs 功能
dayjs.extend(customParseFormat);
class callManageStore {
  commonStore?: CommonStore;

  constructor(baseStore?: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }
  @observable searchForm: any = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getTaskPage();
    },
  };

  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }
  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }
  //分页查询
  @action
  getTaskPage() {
    this.commonStore?.getPagePermission("calling_card_signature_management");
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.callManageApi
      .getCallPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
        }
        this.geAllList()  //话术下拉
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }
  setLookPower(obj: any) {
    runInAction(() => {
      this.lookPower = { ...this.lookPower, ...obj };
    });
  }


  //生成id
  generateId() {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    // bits 12-15 of the time_hi_and_version field to 0010
    s[14] = '4';
    // bits 6-7 of the clock_seq_hi_and_reserved to 01
    const clockSeqHiAndReserved = parseInt(s[19], 16);
    s[19] = hexDigits[(clockSeqHiAndReserved & 0x3) | 0x8];
    s[8] = s[13] = s[18] = s[23] = '-';
    const uuid = s.join('');
    return uuid;
  }
  @observable segValue: string = ''; //添加号码的方式 文件上传/手动录入
  @observable current: number = 0; //上一步，下一步
  @observable lookPower: any = {}; //点击编辑框传值
  @observable isOpenPhone: boolean = false //控制添加号码弹框
  @observable applyFormData: any = null; //文件附件
  @observable PhoneTab: any = {}; //手机号码确认框
  @observable numberPoolNo: string = '' //分组名称
  @observable concurrency: number = 4987  //根据话术查并发
  @observable startD: Boolean = false  //开始时间
  @observable endD: Boolean = false  //时间
  @observable showExceptions: Boolean = true  //全部，异常
  @observable disTime: [boolean, boolean] = [false, false]
  @observable newTemporaryId:string = ''
  //编辑框控制字段
  @observable addOrUpdateModal: IModal = {
    add: false,
    update: false,
    updateModalType: (type: "add" | "update") => { },
    get isOpen(): boolean {
      return this.add || this.update;
    },
    open: (type: "add" | "update", data: any) => {
      if (type === "add") {
        runInAction(() => {
          this.lookPower={}
          this.newTemporaryId = this.generateId();
          this.lookPower.temporaryId = this.newTemporaryId;
          this.addOrUpdateModal.add = true;
          this.addOrUpdateModal.update = false;
          this.phoneList = [];
          this.PhoneTabList = [];
          this.AllPhoneCount = 0;
          console.log("iD1:", this.newTemporaryId); // 调试日志
        });
      }
      this.getNumber()
    },
    close: () => {
      runInAction(() => {
        this.addOrUpdateModal.add = false;
        this.addOrUpdateModal.update = false;
        this.lookPower = {};
        this.lookPower.temporaryId = this.newTemporaryId;
        console.log("iD2:", this.lookPower.temporaryId); // 调试日志
      });
    },
  };

  @action
  async getTaskInfo(data: any) {
    api.callManageApi
      .taskInfo(data.taskId)
      .then((res: any) => {
        runInAction(() => {
          const now = dayjs();
          if (!this.addOrUpdateModal.update) {
            this.disTime[0] = dayjs(dayjs(res.data.startTime)).isBefore(now)
          }
          this.AllPhoneCount = 0 //清空被叫号码
          this.addOrUpdateModal.add = false;
          this.addOrUpdateModal.update = true;
          this.phoneList = []  //清空被叫号码
          this.PhoneTabList = [] //清空被叫号码
          this.taskId = res.data.taskId
          this.concurrency = res.data.numberPoolNo
          let list = []
          if (res.data.forbidTimeList == null) {
            list = []
          } else {
            for (let i = 0; i < res.data.forbidTimeList.length; i++) {
              list.push({
                week: res.data.forbidTimeList[i].week,
                time: [dayjs(res.data.forbidTimeList[i].start, 'HH:mm:ss'), dayjs(res.data.forbidTimeList[i].end, 'HH:mm:ss')]
              })
            }
          }
          this.lookPower = {
            taskId: data.taskId,
            taskStatus: res.data.taskStatus,
            taskName: res.data.taskName,  //名称
            script: res.data.taskScript,  //话术
            concurrency: res.data.concurrency,  //并发
            numberList: res.data.explicitNumberList,  //主叫号码
            applicationTime: [dayjs(res.data.startTime), dayjs(res.data.endTime)],
            forbidTimeList: list,
            ringAgainTimes: res.data.recallTimes,  //未接在呼次数
            ringAgainInterval: res.data.recallInterval,  //未接在呼时间
            temporaryId:this.generateId()
          }
        });
      })
      .catch((e: any) => { });
  }
  @observable modalLoading: boolean = false;
  @observable taskId: string = '';

  //确定提交
  @action
  async submit(data: any, type: string) {
    if (data.applicationTime) {
      data.endTime = data.applicationTime[1].format('YYYY-MM-DD HH:mm:ss')
      data.startTime = data.applicationTime[0].format('YYYY-MM-DD HH:mm:ss')
    }
    data.forbidTimeList = this.disposeForbidTimeList(data.forbidTimeList)
    let phone =[]
    for(let i = 0; i < this.PhoneTabList.length; i++){
      phone.push(this.PhoneTabList[i].phone)
    }
    data.phoneList = phone
    data.numberPoolNo = this.numberPoolNo
    if (type == 'add') {  //新增
        console.log(data)
      await api.callManageApi
        .addCreateTask(data)
        .then((res: any) => {
          runInAction(() => {
            this.getTaskPage()
            this.addOrUpdateModal.add = false;
            message.success("成功");
          })
        })
        .catch((err: any) => { })
    } else {  //编辑
      let query = {
        taskId: this.taskId,
        endTime: data.endTime,
        startTime: data.startTime,
        ringAgainTimes: data.ringAgainTimes,
        ringAgainInterval: data.ringAgainInterval,
        forbidTimeList: data.forbidTimeList,
        concurrency: data.concurrency,
        phoneList: this.phoneList,
        temporaryId:this.lookPower.temporaryId
      }
      await api.callManageApi
        .editUpdateTask(query)
        .then((res: any) => {
          runInAction(() => {
            this.getTaskPage()
            this.addOrUpdateModal.add = false;
            this.addOrUpdateModal.update = false;
            message.success("编辑成功");

          })
        })
        .catch((err: any) => { })
    }
  }
  //处理禁呼时间
  disposeForbidTimeList(data: string | any[]) {
    let arr = []
    if (data == undefined) {
      return []
    }
    for (let i = 0; i < data.length; i++) {
      arr.push({
        week: data[i].week,
        start: data[i].time[0].format('HH:mm:ss'),
        end: data[i].time[1].format('HH:mm:ss')
      })
    }
    return arr
  }
  //控制添加号码弹框
  closeDetailModal(record?: any) {
    runInAction(() => {
      this.isOpenPhone = false
      this.segValue = '文件上传'
    })
  }
  //删除异常项
  @action onDelete() {
    runInAction(() => {
      const newData = [...this.PhoneTabList];
      this.PhoneTabList = newData.filter((item) => item.status == 0);
    })
  }
  @observable phoneList: Array<any> = [] //号码列表
  @observable PhoneTabList: Array<any> = [] //操作的号码
  @observable filePhone: Array<any> = [] //上传的号码
  //控制添加号码弹框
  @action onAddPhone() {
    runInAction(() => {
      if(this.AllPhoneCount==0){
        this.current = 0
        this.showExceptions = false
      }else{
        this.showExceptions = true
      }
      let query={
        temporaryId:this.lookPower.temporaryId,
      }
      this.getPhonePageListByWhere(false,true)
      this.getPhoneCount(query)
      this.isOpenPhone = true
      this.segValue = '文件上传'
      this.PhoneTabList = []
      this.resetPhoneData() //重置分页
    })
  }
  //确定被叫号码
  @action submitPhone() {
    runInAction(async () => {
      let query ={
        temporaryId:this.lookPower.temporaryId,
      }
      this.confirmPhone(query)
      if (this.PhoneTabList.length > 10000) {
        message.error('不能超过10000条数据!');
        return
      }
    })
  }
  //确定号码
  @observable isDetailOpen: boolean = false //控制详情弹窗
  @observable taskRecordDetails: any = {}; //详情当前行
  @observable taskRecordTableLoad: boolean = true;//表格加载状态
  @observable status: string = '1' //详情tab切换
  @observable detailsData: any = {} //详情数据
  //分页信息
  @observable taskRecordPageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getTaskPage();
    },
  };
  //控制查看详情弹框
  async onOpenDetail(record?: any) {
    this.status = '1'
    this.detailsData = {}
    this.resetDetails();
    await this.getTaskDetails(record)
      .then(() => {
        runInAction(() => {
          this.isDetailOpen = true;
        });
      })
      .catch((e: any) => { });
  }
  //重置分页
  resetDetails() {
    runInAction(() => {
      this.DetailspageData.page = 1;
      this.DetailspageData.size = 10;
    });
  }
  //分页信息
  @observable DetailspageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.DetailspageData.page = page;
        this.DetailspageData.size = size;
        this.DetailspageData = { ...this.DetailspageData };
      });
      this.getTaskDetails(this.taskRecordDetails);
    },
  };
  //获取详情信息,
  @action
  async getTaskDetails(data: any) {
    this.taskRecordDetails = data
    let query = {
      taskId: data.taskId,
      status: this.status,
      size: this.DetailspageData.size,
      page: this.DetailspageData.page
    }
    await api.callManageApi
      .getTaskDetails(query)
      .then((res: any) => {
        runInAction(() => {
          console.log(res)
          this.detailsData = []
          this.detailsData = res.data
          this.detailsData.concurrency = data.concurrency  //并发
          this.detailsData.throughRate = data.throughRate  //接通率
          this.detailsData.calledSize = data.calledSize  //呼叫数
          this.detailsData.throughSize = data.throughSize //接通书
          this.detailsData.taskName = data.taskName //任务名称
          this.detailsData.finishRate = data.finishRate //任务进度
          this.taskRecordTableLoad = false
        })
      })
      .catch((err: any) => { })
  }

  //任务状态  0.暂停 1.启动 2.终止
  @action
  async setTaskStatus(data: any, status: Number) {
    let query = {
      taskId: data.taskId,
      status: status
    }
    await api.callManageApi
      .setTaskStatus(query)
      .then((res: any) => {
        runInAction(() => {
          message.success("成功");

        })
        this.getTaskPage()
      })
      .catch((err: any) => { })
  }

  //控制查看详情弹框
  onOpenFalse(record?: any) {
    runInAction(() => {
      this.isDetailOpen = false
    })
  }

  @observable getAllbotList: any = [];  //话术下拉框
  //话术
  @action
  async geAllList() {
    api.languageApi
      .botAllList()
      .then((res: any) => {
        runInAction(() => {
          this.getAllbotList = res.data;
        });
      })
      .catch((e: any) => { });
  }

  @observable numberList: any = [];  //主叫号码列表
  //号码池及号码（主叫号码）
  @action
  async getNumber() {
    api.callManageApi
      .getNumberPool()
      .then((res: any) => {
        runInAction(() => {
          this.numberList = res.data;
        });
      })
      .catch((e: any) => { });
  }





  //确定号码分页
  resetPhoneData() {
    runInAction(() => {
      this.phoneData.page = 1;
      this.phoneData.size = 10;
    });
  }
  //确定号码分页
  @observable phoneData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.phoneData.page = page;
        this.phoneData.size = size;
        this.phoneData = { ...this.phoneData };
      });
      if(this.showExceptions){
        this.getPhonePageListByWhere(false,false)
      }else{
        this.getPhonePageListByWhere(true,false)
      }
      
    },
  };

  //手动录入下一步--添加号码
  @action
  async addPhone(phoneList: string[]) {
    let query ={
      temporaryId:this.lookPower.temporaryId,
      phoneList:phoneList
    }
    api.callManageApi.addPhone(query)
      .then((res: any) => {
        runInAction(() => {
          this.getPhonePageListByWhere(true,false)
        });
      })
      .catch((e: any) => { });
  }

  @observable allPhone: any = {} //分页数据
  @observable AllPhoneCount: number = 0 //分页数据
  @observable showDelete: boolean = false //删除全部异常禁用
  //根据临时id查询号码列表
  @action
  async getPhonePageListByWhere(show: boolean,isOk:boolean) {
    let data: { temporaryId: any;isOk?: number; state?: number ;size: number; page: number} = {
      temporaryId: this.lookPower.temporaryId,
      size: this.phoneData.size,
      page: this.phoneData.page,
    };
    if(show){
      data.state = 1
    }
    if(isOk){
      data.isOk = 1
    }
    const query = { ...data};
    data.size = this.phoneData.size;
    data.page = this.phoneData.page;
    api.callManageApi.getPhonePageListByWhere(query)
      .then((res: any) => {
        runInAction(() => {
          if(res.data.records !=0){
            this.current = 1
          }
          if(data.state==1){
            if(res.data.records.length==0){
              this.showDelete = true
            }else{
              this.showDelete = false
            }
          }
          this.allPhone = res.data
          this.PhoneTabList = res.data.records
        });
      })
      .catch((e: any) => { });
  }
  //删除临时id查询号码列表
  @action
  async deletePhone(data: { temporaryId: any; state?: number; ids?: string[]; }) {
    api.callManageApi.deletePhone(data)
      .then((res: any) => {
        runInAction(() => {
          if(this.showExceptions){
            this.getPhonePageListByWhere(false,false)
          }else{
            this.getPhonePageListByWhere(true,false)
          }
        });
      })
      .catch((e: any) => { });
  }
  //查询添加号码数量
  @action
  async getPhoneCount(data: { temporaryId: any; }) {
    api.callManageApi.getPhoneCount(data)
      .then((res: any) => {
        runInAction(() => {
          this.AllPhoneCount = res.data
        });
      })
      .catch((e: any) => { });
  }
  //确定号码
  @action
  async confirmPhone(data: { temporaryId: any; }) {
    api.callManageApi.confirmPhone(data)
      .then((res: any) => {
        runInAction(async() => {
          console.log(res)
          if(res.code==200){
            this.getPhonePageListByWhere(false,false)
            this.closeDetailModal()
            let query={
              temporaryId:this.lookPower.temporaryId,
            }
            this.getPhoneCount(query)
          }
        });
      })
      .catch((e: any) => { });
  }
}

export default callManageStore;